import controller from './loginSuperAdmin.controller';
import template from './loginSuperAdmin.html';

const loginSuperAdminComponent = {
  restrict: 'E',
  bindings: {
    onLoginCompleted: '&'
  },
  template,
  controller
};

export default loginSuperAdminComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/loginSuperAdmin/loginSuperAdmin.component.js
 **/